/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Biometric template storage methods */
export enum BiometricStorageMethod {
  OnDevice,
  Encrypted,
  Hashed,
  Distributed,
  None,
}

export type BiometricStorageMethodArgs = BiometricStorageMethod;

export function getBiometricStorageMethodEncoder(): FixedSizeEncoder<BiometricStorageMethodArgs> {
  return getEnumEncoder(BiometricStorageMethod);
}

export function getBiometricStorageMethodDecoder(): FixedSizeDecoder<BiometricStorageMethod> {
  return getEnumDecoder(BiometricStorageMethod);
}

export function getBiometricStorageMethodCodec(): FixedSizeCodec<
  BiometricStorageMethodArgs,
  BiometricStorageMethod
> {
  return combineCodec(
    getBiometricStorageMethodEncoder(),
    getBiometricStorageMethodDecoder(),
  );
}
